import { render, staticRenderFns } from "./TeamWorkForm.vue?vue&type=template&id=d5fab18e"
import script from "./TeamWorkForm.vue?vue&type=script&lang=js"
export * from "./TeamWorkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports